import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideHttpClientTesting } from '@angular/common/http/testing';
import { NgModule } from '@angular/core';
import { environment } from '@telespot/shared/environment';

import { LOGGER_CONFIG, LoggerLevel } from './logger.config';
import type { ILoggerConfig } from './logger.config';

@NgModule({ imports: [], providers: [
        {
            provide: LOGGER_CONFIG,
            useValue: {
                level: environment.logging?.level ?? 0,
                serverLogLevel: environment.serverLogging?.level ?? 5,
                httpHeaders: new HttpHeaders()
                    .set('Content-Type', 'application/json; charset=utf-8')
                    .set('X-API-Key', environment.serverLogging?.apiKey)
                    .set('X-App-Id', environment.serverLogging?.appId),
            } as ILoggerConfig,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class LoggerModule {}

@NgModule({ exports: [LoggerModule], imports: [LoggerModule], providers: [
        {
            provide: LOGGER_CONFIG,
            useValue: {
                level: LoggerLevel.DEBUG,
                serverLogLevel: null,
            } as ILoggerConfig,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideHttpClientTesting(),
    ] })
export class LoggerTestingModule {}
